module.exports = __webpack_public_path__ + "static/media/registp04_zhChs.46b24dd8.png";